<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'containerComponents.countrySelection.dialog.selectCountry' | translate }}
  </h1>
  <div mat-dialog-content>
    <div [hidden]="noCountryExist()">
      <ui-list-filter [filtersConfig]="filterConfig" (filtersChange)="changed($event)"></ui-list-filter>
      <mat-table [dataSource]="filteredOptionItems$ | async" noDataTableMessage>
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle($event.checked) : null"
              [checked]="(hasValue$ | async) && isAllSelected()"
              [indeterminate]="(hasValue$ | async) && !isAllSelected()"
            >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? toggle(row, $event.checked) : null"
              [checked]="selectedRows.has(row.id)"
            >
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.name' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.countryCode' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.id }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.selected]="selectedRows.has(row.id)"
          (click)="toggle(row, !selectedRows.has(row.id))"
        ></mat-row>
      </mat-table>
    </div>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      [action]="buttonAction.Save"
      [type]="buttonType.Primary"
      (buttonClick)="confirm()"
    ></ui-action-button>
  </div>
</div>
